import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    // Handle escape key
    this.handleEscapeBound = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.handleEscapeBound)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEscapeBound)
  }

  open(event) {
    const modalId = event.currentTarget.dataset.modalTarget || event.currentTarget.dataset.modalId
    const modal = document.getElementById(modalId)
    
    if (modal) {
      modal.classList.remove('hidden')
      
      // Dispatch a modal opened event
      modal.dispatchEvent(new CustomEvent('modal:opened', { bubbles: true }))
    }
  }

  close(event) {
    // Prevent default action if this was triggered by a click
    event?.preventDefault()
    
    const modal = this.element
    if (modal) {
      modal.classList.add('hidden')
      
      // Dispatch a modal closed event
      modal.dispatchEvent(new CustomEvent('modal:closed', { bubbles: true }))
    }
  }

  handleEscape(event) {
    if (event.key === "Escape") {
      // Only handle escape if this modal is visible
      const isVisible = !this.element.classList.contains("hidden")
      const isTopModal = Array.from(document.querySelectorAll('[role="dialog"]')).every(modal => {
        return modal === this.element || modal.classList.contains("hidden")
      })

      if (isVisible && isTopModal) {
        this.close()
      }
    }
  }

  closeOnOutsideClick(event) {
    // Only close if closeOnOutsideClick is enabled and the click is on the backdrop
    if (this.element.dataset.closeOnOutsideClick !== 'false') {
      // Check if the click is on the actual backdrop and not on any of its children
      if (event.target === event.currentTarget) {
        event.preventDefault()
        this.close()
      }
    }
  }
} 
